<template>
    <div class="p-3">
        <div class="row mb-2">
            <div class="col">
                <button class="btn btn-primary btn-sm" @click="openForm">Log Communication</button>
            </div>
        </div>
        <div v-if="loadingLogs">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
        <div v-else class="row row-cols-1">
            <comm-log-card
                v-for="log in logs" 
                :key="log.id"
                :log="log"
                :participant="participant"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import CommLogCard from './CommLogCard.vue'

export default {
    name: "CommLogList",
    components: {
        CommLogCard
    },
    props: { 
        participant: Object,
    },
    methods: {
    	openForm() {
            this.$store.dispatch('communications/setFormOpen', true)
        },
        closeForm() {
            this.$store.dispatch('communications/closeForm')
        }
    },
    computed: {
        ...mapState({
            loadingLogs: state => state.communications.loadingLogs,
            logs: state => state.communications.logs,
            formOpen: state => state.communications.formOpen
        })
    },
    mounted () {
    	this.$store.dispatch('communications/setParticipant', this.participant)
        this.$store.dispatch('communications/setContacts', this.participant.contacts)
        this.$store.dispatch('communications/fetchLogs', {'participant_id': this.participant.id})
    }
}

</script>